import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-param',
  templateUrl: './delete-param.component.html',
  styleUrls: ['./delete-param.component.css']
})
export class DeleteParamComponent implements OnInit {

  paramData:any = []
  deleteId: any = "";
  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getParamsData()
 
  } 
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getParamsData(){
    this.generic_service.getParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteParam(){
    this.generic_service.deleteParam(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getParamsData();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }
}
